import React from 'react'
import BaseHeadline from '../../../components/general/BaseHeadline'
import BaseIcon from '../../../components/general/BaseIcon'
import { BaseCardContainer } from '../../../components/general/BaseCard'
import BaseGhostButton from '../../../components/general/BaseGhostButton'


type AboutIntroType = {
    heading: {
        label?: string
        headline: string
        text?: string
    }
    cards: {
        lucideIcon: string
        title: string
        text: string
    }[]
}
export default function AboutIntro(props: AboutIntroType) {
    return (
        <section className="py-20 px-4 w-full sm:px-8 xl:px-32">
            <div className="w-full grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 xl:gap-24 ">
                <div className='col-span-1 lg:col-span-5 flex flex-col justify-between lg:pb-24'>
                    <BaseHeadline
                        headline={props.heading.headline}
                        tag='h2'
                        text={props.heading.text}
                        label={props.heading.label}
                        width='w-fit'
                        headlineClassProps='!leading-[1.2]'
                    />
                    <BaseGhostButton
                        text={'Kontakt aufnehmen'}
                        url={'/contact#_'}
                        classProps='ml-1 hidden lg:flex'
                    />

                </div>
                <div className='col-span-1 lg:col-span-7 grid sm:grid-cols-2 gap-8'>
                    {/* <div className={`row-span-1 h-20 `} /> */}

                    {props.cards.map((card, index) => (
                        <React.Fragment key={index}>
                            <div className={`row-span-1 h-20 ${index === 1 ? "hidden sm:block" : "hidden"}`} />

                            <BaseCardContainer key={index} className='col-span-1 row-span-2 flex flex-col gap-4 p-6 h-fit'>
                                <div className={`${index % 2 === 0 ? "text-primary" : "text-secondary"} `}>
                                    <BaseIcon name={card.lucideIcon} size={24} />
                                </div>
                                <BaseHeadline
                                    tag='h3'
                                    headline={card.title}
                                    text={card.text}
                                    width='w-fit'
                                    headlineClassProps='!text-2xl'
                                />
                            </BaseCardContainer>
                        </React.Fragment>
                    ))}

                </div>
            </div>
        </section>
    )
}
